export default (props) => (
  <svg
    width="89"
    height="45"
    viewBox="0 0 89 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <title>Vouch logo</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.1992 22.4718C30.1992 18.9559 28.842 17.7351 27.0782 17.7351C25.4683 17.7351 23.9573 18.9559 23.9573 22.4718C23.9573 25.9874 25.4683 27.2085 27.0782 27.2085C28.7051 27.2085 30.1992 25.9874 30.1992 22.4718ZM18.161 22.4718C18.161 16.2814 21.3936 12.7518 27.0782 12.7518C32.763 12.7518 35.9953 16.2613 35.9953 22.4718C35.9953 28.6908 32.763 32.1918 27.0782 32.1918C21.3936 32.1918 18.161 28.7229 18.161 22.4718Z"
      fill="#222222"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.9882 22.4718C54.9882 16.2227 58.4724 12.7518 63.6403 12.7518C68.7958 12.7518 71.6592 15.3654 71.9031 20.1464H66.1349C65.8703 18.1888 65.0571 17.6243 63.6547 17.6243C61.7792 17.6243 60.7845 19.0851 60.7845 22.4718C60.7845 25.7882 61.853 27.3193 63.6547 27.3193C65.0842 27.3193 65.8703 26.8339 66.1349 24.7972H71.9031C71.6972 29.5844 68.5172 32.1918 63.7105 32.1918C58.1702 32.1918 54.9882 28.626 54.9882 22.4718Z"
      fill="#222222"
    />
    <mask
      id="mask0_3142_55"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="73"
      y="13"
      width="16"
      height="19"
    >
      <path
        d="M73.6598 13.3615H88.8623V31.5826H73.6598V13.3615Z"
        fill="#121C2B"
      />
    </mask>
    <g mask="url(#mask0_3142_55)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.6595 13.3614H79.1628V20.025H83.3588V13.3614H88.862V31.5825H83.3588V24.8565H79.1628V31.5825H73.6595V13.3614Z"
        fill="#222222"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.6574 13.3677H43.078V25.0592C43.078 26.4952 43.8247 27.6456 45.2706 27.6456C46.861 27.6456 47.8059 26.6724 47.8059 24.2218V13.3611H53.2338V31.5564H47.8059V29.4194C47.1649 30.97 45.2819 32.0684 43.3297 32.0684C39.643 32.0684 37.6574 29.68 37.6574 25.7181V13.3677Z"
      fill="#222222"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0164 13.3611L9.50755 25.3053L6.9686 13.3611H0.862305L6.34257 31.5822H12.642L18.1615 13.3611H12.0164Z"
      fill="#222222"
    />
    <mask
      id="mask1_3142_55"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="49"
      y="33"
      width="30"
      height="8"
    >
      <path d="M49.0943 33.6183H78.3569V41H49.0943V33.6183Z" fill="white" />
    </mask>
    <g mask="url(#mask1_3142_55)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.7255 36.2054C60.5027 36.2054 58.2289 35.1769 56.1531 33.6183H49.0942C52.3304 38.1965 57.5275 41 63.7255 41C69.9235 41 75.1205 38.1965 78.3568 33.6183H71.2975C69.2221 35.1769 66.9483 36.2054 63.7255 36.2054Z"
        fill="#222222"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.2341 6.84614C34.4193 5.02672 31.033 4 27.288 4C23.5429 4 20.1742 5.02672 17.3823 6.84614C15.6038 8.00537 14.0613 9.48737 12.8065 11.2353H19.9352C21.9642 9.76687 24.1935 8.79445 27.288 8.79445C30.3825 8.79445 32.6307 9.76687 34.6839 11.2353H41.8561C40.5861 9.48737 39.0272 8.00537 37.2341 6.84614Z"
      fill="#222222"
    />
  </svg>
)
